class ExpectedDelivery extends HTMLElement {
  constructor() {
    super();

    this.settings = JSON.parse(this.dataset.deliverySettings);

    this.dateEle = this.querySelector('.expected-delivery__date');

    this.init();
  }

  init() {
    if (this.dateEle !== null) {
      const { timeToDeliver, localeString, cutOfTime, preorderDeliveryDate } = this.settings;

      var formattetDeliveryTime = new Date();
      // check if any of the products are preorder products
      if (preorderDeliveryDate.length > 0) {
        // find what date in the preorderDeliveryDate array is furthest in the future
        const furthestDate = preorderDeliveryDate.reduce((prev, curr) => {
          return new Date(prev) > new Date(curr) ? prev : curr;
        });

        // make sure furthest date is not in the past
        if (new Date(furthestDate) < new Date()) {
          formattetDeliveryTime = this.toString(
            this.computeDeliveryDate(new Date(), cutOfTime, timeToDeliver),
            localeString
          );
        } else {
          formattetDeliveryTime = this.toString(new Date(Date.parse(furthestDate)), localeString);
        }
      } else {
        formattetDeliveryTime = this.toString(
          this.computeDeliveryDate(new Date(), cutOfTime, timeToDeliver),
          localeString
        );
      }

      this.dateEle.innerHTML = formattetDeliveryTime;
    }
  }

  computeDeliveryDate(date, cutOfTime, timeToDeliver) {
    var addedDays = 0;
    const cutOfHour = parseInt(cutOfTime.split(':')[0]);
    const cutOfMin = parseInt(cutOfTime.split(':')[1]);
    const timeNowHour = parseInt(date.getHours());
    const timeNowMin = parseInt(date.getMinutes());

    const isFriday = date.getDay() === 5;
    const afterCutOfTime = timeNowHour > cutOfHour || (timeNowHour > cutOfHour && timeNowMin >= cutOfMin);

    //if friday and before cut of time or just in the weekends
    if ((isFriday && !afterCutOfTime) || date.getDay() === 6 || date.getDay() === 0) {
      return getNextMonday();
    }

    // takes x days to deliver
    addedDays += timeToDeliver;

    // if after cut so we add another day
    if (afterCutOfTime) {
      // But if friday and after cut of time
      if (isFriday) {
        return addDays(getNextMonday(), addedDays);
      }

      // if day = monday - thursday
      addedDays++;
    }

    // if delivery date is weekend, then set the delivery date to monday
    // else add the timeToDeliver days to the delivery date
    if (this.isWeekend(this.addDays(date, addedDays))) {
      return this.getNextMonday();
    } else {
      return this.addDays(date, addedDays);
    }
  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  isWeekend(date = new Date()) {
    return date.getDay() === 6 || date.getDay() === 0;
  }

  getNextMonday(date = new Date()) {
    const dateCopy = new Date(date.getTime());

    const nextMonday = new Date(dateCopy.setDate(dateCopy.getDate() + ((7 - dateCopy.getDay() + 1) % 7 || 7)));

    return nextMonday;
  }

  toString(date, localeString) {
    const dayNumber = date.getDate();
    const dayText = date.toLocaleString(`${localeString}`, { weekday: 'long' });
    const month = date.toLocaleString(`${localeString}`, { month: 'long' });
    const year = date.getFullYear();
    return `${dayText}, ${dayNumber}. ${month} ${year}`;
  }
}

customElements.define('expected-delivery', ExpectedDelivery);
